// Updated index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { initializeFaro, ReactIntegration, getWebInstrumentations } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { routes } from './App';
import './index.css';
import './styles.css';

const router = createBrowserRouter(routes);

// Initialize Faro
initializeFaro({
  url: 'https://faro-collector-prod-au-southeast-1.grafana.net/collect/9566dd957270c7e16013444c357137db',
  app: {
    name: 'bestsalescoachapp',
    version: '1.0.0',
    environment: 'production',
  },
  instrumentations: [
    ...getWebInstrumentations(),
    new TracingInstrumentation(),
    new ReactIntegration({
      router,
      onNavigate: (location) => console.log('Navigated to:', location.pathname),
      onError: (error) => console.error('Faro route error:', error),
    }),
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router} />);
